module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_9006.61144b7a.png";